import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { useParams, useLocation } from "react-router-dom";
import SurveyList from './ExecutiveReportSurveyList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../../../utils/UrlUtil';
import { AccountContext } from '../../../../components/AccountContext';

const LIST_QUERY = gql`
  query executiveReportSurveyQuery(
    $accountId: ID!
    $executiveId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: ExecutiveReportSurveyFilter
  ) {
    account(id: $accountId) {
      id
      executiveReport(id: $executiveId) {
        id
        surveys(first: $first, last: $last, before: $before, after: $after, filter: $filter) {
          totalCount
          indexFrom
          indexTo
          pageInfo {
            startCursor
            endCursor
            hasPreviousPage
            hasNextPage
          }
          edges {
            node {
              id
              name
              firstName
              lastName
              date
              statuses
            }
          }
        }
      }
    }
  }
`;

const ExecutiveReportSurveyListContainer = () => {
  const currentAccount = useContext(AccountContext);
  const location = useLocation();
  const { reportId } = useParams();
  const params = parse(location.search);
  const pagination = filterPaginationWithSize(params);
  const variables = {
    ...pagination,
    accountId: currentAccount,
    sort: params.sort,
    filter: params.filter,
    executiveId: reportId,
  };
  return (
    <Query query={LIST_QUERY} variables={variables}>
      {({ data, loading, error }) => {
        if (error) return `Error! ${error.message}`;

        const connection =
          data && data.account && data.account.executiveReport
            ? data.account.executiveReport.surveys
            : emptyConnection();

        return <SurveyList connection={connection} loading={loading} />;
      }}
    </Query>
  );
};

export default ExecutiveReportSurveyListContainer;
